import { NavLink } from 'react-router-dom';
import './styles/Assesment.css';
import PractiseTest from '../../images/assessment/PractiseTest';
import Go from '../../images/assessment/Go';
import OnlineTest from '../../images/assessment/OnlineTest';
import {useParams} from 'react-router-dom'
import {useMediaQuery} from 'react-responsive';

import { fixName } from '../helpers';

const Assesment = ({ tests }) => {

  const params = useParams()
  const isSmall = useMediaQuery({query:"(max-width:472px)"})
  console.log(tests);
  return (
    <>
      <div className='tests-links'>
        <NavLink to={`/learningresources/${fixName(params.subject)}/${params.subjectId}/${fixName(params.chapter)}/${params.chapterId}/topic/${fixName(params.topic)}/${params.topicId}/practice-session`} className='link-box'>
          <PractiseTest />
          <p>&nbsp;Practice Session</p>
          {!isSmall && <Go />}
        </NavLink>
        <NavLink
          to={`/learningresources/${fixName(params.subject)}/${params.subjectId}/${fixName(params.chapter)}/${params.chapterId}/topics/${params.topicId}/${fixName(params.topic)}/tests`}
          className='link-box secondary-box'
        >
          <OnlineTest />
          <p>&nbsp;Online Test</p>
          {!isSmall && <Go />}
        </NavLink>
      </div>
      
    </>
  );
};

export default Assesment;
